import * as React from 'react';

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Granularity } from 'bloggers-backend/lib/bloggers/domain';
import { statuses } from 'bloggers-backend/lib/bloggers/dicts/statuses';
import { DateRange } from '@mui/x-date-pickers-pro';
import dayjs, { Dayjs } from 'dayjs';
import { useGrowthReport } from '../hooks/useGrowthReport';
import { ReportControls } from './ReportControls';
import { ReportPeriodsView } from './ReportPeriodsView';

export function GrowthReportPage() {
  const [granularity, setGranularity] = React.useState<Granularity>('month');
  const [status, setStatus] = React.useState('affiliate');
  const [dateRange, setDateRange] = React.useState<DateRange<Dayjs>>([
    dayjs().subtract(12, 'month'), dayjs()
  ]);

  const [startDate, endDate] = dateRange;
  const { data, isLoading, error } = useGrowthReport(
    {
      granularity,
      status,
      startDate: startDate?.format('YYYY-MM-DD') ?? '',
      endDate: endDate?.format('YYYY-MM-DD') ?? '',
    },
    Boolean(startDate?.isValid() && endDate?.isValid())
  );

  return (
    <>
      <ReportControls
        granularity={granularity}
        onGranularityChange={setGranularity}
        dateRange={dateRange}
        onDateRangeChange={setDateRange}
      >
        <FormControl sx={{ minWidth: 180 }}>
          <InputLabel id="status-label">status</InputLabel>
          <Select
            id="status"
            labelId="status-label"
            label="status"
            value={status}
            onChange={(event) => setStatus(event.target.value)}
          >
            {statuses.map(option => <MenuItem key={option} value={option}>{option}</MenuItem>)}
          </Select>
        </FormControl>
      </ReportControls>
      <ReportPeriodsView
        users={data?.users}
        periods={data?.periods}
        isLoading={isLoading}
        error={error}
        chartTitle={`Growth: ${status} (${granularity})`}
        chartTestId="growth-report-chart"
      />
    </>
  );
}
